<h2 mat-dialog-title class="balance-charge-breakdown-dialog__title">
  <span>{{ 'balance.review.breakdown.title' | translate }}</span>
  <small>{{ 'balance.review.breakdown.code-count' | translate: { count: chargeCount } }}</small>
</h2>

<mat-dialog-content>
  <mmx-balance-charge-breakdown
    [charges]="data.charges"
    [total]="data.total"
    panelId="balance-charge-breakdown-dialog"
    [showHeader]="false"
  ></mmx-balance-charge-breakdown>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" mat-dialog-close>{{ 'common.close' | translate }}</button>
</mat-dialog-actions>
